import { render, staticRenderFns } from "./HorizontalAlignment.vue?vue&type=template&id=5fccb539&"
import script from "./HorizontalAlignment.vue?vue&type=script&lang=js&"
export * from "./HorizontalAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports